// extracted by mini-css-extract-plugin
export default {"root":"FieldsDiff_root__vd2Nf","name":"FieldsDiff_name__DbMKY","change":"FieldsDiff_change__Lwz4a","oldValue":"FieldsDiff_oldValue__ncoit","newValue":"FieldsDiff_newValue__poOss"};